module.exports = __webpack_public_path__ + "static/img/caf7a737ef60e0eaf0ed125e7ea747f.22482b43.png";